import { render, staticRenderFns } from "./PaymentOrder.vue?vue&type=template&id=3fbe2fbe&scoped=true&"
import script from "./PaymentOrder.vue?vue&type=script&lang=ts&"
export * from "./PaymentOrder.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentOrder.vue?vue&type=style&index=0&id=3fbe2fbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe2fbe",
  null
  
)

export default component.exports